export function audienceRoleLabel(role?: string | null): string | null {
  if (!role) return null;
  switch (role.toLowerCase()) {
    case "all":
      return "All";
    case "coach":
      return "Coaches";
    case "director":
      return "Directors";
    case "manager":
      return "Managers";
    case "student":
      return "Learners";
    case "admin":
      return "Admins";
    default:
      return role;
  }
}
